const COMMON_IMAGES_ENDPOINTS = [
	// 首页获取推荐图片
	/api\/resources\/v1\/images\/recommends/,
	// 个人主页图片
	/api\/resources\/v1\/images\/home/,
	// 应用详情页其他图片
	/api\/community\/v1\/publications\/[\d\w]+\/images/,
	// 图片详情页推荐图片
	/api\/resources\/v1\/images\/[\d\w]+\/recommend/,
];

const COMMON_IMAGES_HOME_FAVORITE = [
	// 个人主页喜欢的图片
	/api\/resources\/v1\/images\/like/,
];

const COMMON_IMAGES_TASK = [
	// 任务列表生成图片
	/api\/resources\/v1\/task\/task-pend\/list/,
];

export const IMAGES_ENDPOINTS = {
	COMMON: COMMON_IMAGES_ENDPOINTS,
	FAVORITE: COMMON_IMAGES_HOME_FAVORITE,
	TASK: COMMON_IMAGES_TASK,
};

export const COMMON_POSTS_ENDPOINTS = [
	/api\/resources\/v1\/posts\/list/,
	/api\/resources\/v1\/posts\/home/,
];
